module.exports = __webpack_public_path__ + "img/allemand2de.d6d3e5fd.png";